import { soundManager, SoundType } from '../domain/sound/SoundManager'
import { Button } from '../UI/Button'

interface CloseButtonV2Props {
  x: number
  y: number
  width: number
  height: number
  onPress: () => void
}

export const CloseButtonV2 = (props: CloseButtonV2Props) => {
  return (
    <Button
      name="CloseButton"
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPress={props.onPress}
      defaultView="close_btn_normal"
      hoverView="close_btn_hover"
      onPressing={() => {
        soundManager.play(SoundType.buttonClose)
      }}
      pressedView="close_btn_click"
    />
  )
}
